import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Title: {
    color: '#424242',
    borderBottom: '1px solid grey',
    backgroundColor: '#f1f1f1',
    padding: '10px',
  },
  Container: {
    marginLeft: '25px',
  },
  Field: {
    display: 'grid',
    padding: '10px',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  EventTypeForm: {
    borderBottom: '1px solid lightgray',
  },
});
